import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';


type AuthContextType = {
    user: AuthUser | undefined,
    idToken?: JWT | undefined,
    accessToken?: JWT | undefined,
    cognitoGroups?: string[] | undefined,
    role?: string | undefined,
}


export const AuthContext = createContext<AuthContextType>({
                                                              user: {} as AuthUser,
                                                          });

